var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOccupancy = function SvgOccupancy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "occupancy_svg__a",
    x: 0,
    y: 0,
    width: 79,
    height: 31.662,
    rx: 2.328
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.244 8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "occupancy_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#occupancy_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#occupancy_svg__b)",
    stroke: "#36CFC9",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-7.088 27.229 7.513-.357 15.52 3.35L31.81 17.5l16.882-.206L63.389 9.27l15.426-5.24h6.98"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.118)",
    fill: "#36CFC9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.316,
    cy: 28.142,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.035,
    cy: 24.788,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.428,
    cy: 15.406,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.316,
    cy: 15.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.019,
    cy: 7.169,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.2,
    cy: 1.882,
    r: 1
  })))));
};
export default SvgOccupancy;